import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import AppLayout from "../components/AppLayout";
import { Loader2, CheckCircle2, XCircle, Download, Rocket } from "lucide-react";
import { toast } from "sonner";

import { _t } from "@/lib/i18n";
export default function VoucherSuccess() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  const nav = useNavigate();
  const [status, setStatus] = useState("polling");
  const [voucher, setVoucher] = useState(null);
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!orderId) { setStatus("error"); return; }
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/vouchers/orders/${orderId}/status`);
        if (data.payment_status === "paid" && data.voucher_id) {
          setStatus("paid");
          setVoucher({ id: data.voucher_id, public_id: data.voucher_public_id });
          return;
        }
        if (attempts > 30) { setStatus("timeout"); return; }
        setAttempts((a) => a + 1);
        timer = setTimeout(poll, 2000);
      } catch (e) {
        toast.error(formatApiError(e));
        setStatus("error");
      }
    };
    poll();
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [orderId]);

  return (
    <AppLayout>
      <div className="max-w-2xl mx-auto py-16 text-center" data-testid="voucher-success">
        {status === "polling" && (
          <>
            <Loader2 className="w-10 h-10 text-[#FF5722] animate-spin mx-auto mb-6" />
            <h1 className="font-display text-4xl text-white mb-3">{_t("Confermo il pagamento...")}</h1>
            <p className="text-white/60">{_t("Attendi qualche secondo, sto emettendo il voucher.")}</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-16 h-16 text-green-400 mx-auto mb-6" />
            <h1 className="font-display text-4xl text-white mb-3">{_t("Voucher emesso")}</h1>
            <p className="text-white/60 mb-8">{_t("Il tuo voucher è stato aggiunto alla capsula.")}</p>
            <div className="flex flex-wrap gap-3 justify-center">
              <a href={`${api.defaults.baseURL}/vouchers/${voucher.id}/pdf?auth=${encodeURIComponent(localStorage.getItem("tc_access_token") || "")}`}
                 target="_blank" rel="noreferrer" className="btn-ghost" data-testid="download-pdf-btn">
                <Download className="w-4 h-4" />{" "}{_t("Scarica il PDF")}</a>
              <button onClick={() => nav("/dashboard")} className="btn-launch">
                <Rocket className="w-4 h-4 -rotate-45" />{" "}{_t("Torna alla dashboard")}</button>
            </div>
            <div className="mt-6 text-xs text-white/40">{_t("Numero voucher:")}{" "}<span className="text-white/70 font-mono-launch">{voucher.public_id}</span></div>
          </>
        )}
        {status === "timeout" && (
          <>
            <XCircle className="w-14 h-14 text-yellow-400 mx-auto mb-6" />
            <h1 className="font-display text-3xl text-white mb-3">{_t("In attesa di conferma")}</h1>
            <p className="text-white/60 mb-6">{_t("Il pagamento sta impiegando più del previsto. Puoi controllare più tardi dalla dashboard.")}</p>
            <button onClick={() => nav("/dashboard")} className="btn-launch">{_t("Torna alla dashboard")}</button>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="w-14 h-14 text-red-400 mx-auto mb-6" />
            <h1 className="font-display text-3xl text-white mb-3">{_t("Qualcosa è andato storto")}</h1>
            <button onClick={() => nav("/dashboard")} className="btn-launch">{_t("Torna alla dashboard")}</button>
          </>
        )}
      </div>
    </AppLayout>
  );
}
